import {
  faAnalytics,
  faArrowAltCircleDown,
  faCartShopping,
  faCheckCircle as faCheckCircleLight,
  faClipboardListCheck,
  faClock,
  faCommentDots,
  faCommentsDollar,
  faCopy,
  faDesktop,
  faDoorClosed,
  faEnvelope as faEnvelopeLight,
  faEnvelopeOpen,
  faEnvelopeOpenText as faEnvelopeOpenTextLight,
  faFileInvoiceDollar,
  faFolderPlus,
  faMagic,
  faMapMarkerAlt,
  faPaperclip as faPaperclipLight,
  faPen as faPenLight,
  faPhone,
  faPhoneAlt,
  faQuestion as faQuestionLight,
  faSignal,
  faSmile as faSmileLight,
  faSync as faSyncLight,
  faTimes as faTimesLight,
  faUserCog,
  faUserFriends,
  faUserPlus,
  faUsers,
  faWalking,
} from '@fortawesome/pro-light-svg-icons';

const proLightSvgIcons = {
  analyticsLight: faAnalytics,
  checkCircleLight: faCheckCircleLight,
  clipboardList: faClipboardListCheck,
  clockLight: faClock,
  closeLight: faTimesLight,
  commentsDollar: faCommentsDollar,
  copyLight: faCopy,
  desktopComputer: faDesktop,
  doorClosed: faDoorClosed,
  envelopeOpen: faEnvelopeOpen,
  smileLight: faSmileLight,
  fileInvoiceDollar: faFileInvoiceDollar,
  folderPlus: faFolderPlus,
  magic: faMagic,
  mailLight: faEnvelopeLight,
  mailOpenTextLight: faEnvelopeOpenTextLight,
  mapAltLight: faMapMarkerAlt,
  paperclip: faPaperclipLight,
  penLight: faPenLight,
  phoneAltLight: faPhoneAlt,
  phoneLight: faPhone, // Since the alt phone is already exported without prefix for regular and solid, we will add it in light as well for consistency
  questionLight: faQuestionLight,
  refreshLight: faSyncLight,
  scoreDown: faArrowAltCircleDown,
  signal: faSignal,
  smsLight: faCommentDots,
  teamLight: faUsers,
  userCog: faUserCog,
  userPlus: faUserPlus,
  usersLight: faUserFriends,
  walking: faWalking,
  shoppingCart: faCartShopping,
};

export { proLightSvgIcons };
